import { useState, useEffect } from "react";
import axios from "axios";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import useAuth from "../hooks/useAuth";
import CartMobile from "./CartMobile";
import MenuMobile from "./MenuMobile";
import NavBar from "./NavBar";
import usePrivateApi from "../hooks/usePrivateApi";

const Logo = () => (
  <img
    src={logo}
    alt={process.env.REACT_APP_NAME}
    className="w-[160px] lg:w-60"
  />
);

const Header = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { auth } = useAuth();
  const privateApi = usePrivateApi();

  // ➜ Stato per memorizzare il banner
  const [banner, setBanner] = useState(null);

  // ➜ Recupera il messaggio attivo dal server
  useEffect(() => {
    async function fetchBanner() {
      try {
        const response = await privateApi.get("/messages");
        if (response.data && response.data.is_active) {
          // Se il messaggio è attivo, lo salviamo
          setBanner(response.data);
        } else {
          setBanner(null);
        }
      } catch (error) {
        console.error("Errore nel recupero del banner:", error);
        setBanner(null);
      }
    }
    fetchBanner();
  }, []);

  return (
    <>
      {/* HEADER */}
      <div className="sticky top-0 z-10 flex items-center h-20 grid-cols-3 px-4 bg-white border-b-2 border-yellow lg:grid lg:px-24">
        <div className="justify-self-start">
          {!auth.accessToken &&
          (location.pathname === "/register" ||
            location.pathname === "/forgot-password") ? (
            <NavLink className="flex items-center" to="/login">
              <ChevronLeftIcon className="w-5 h-5 mr-1" />
              <span className="font-medium"> {t("Back to login")}</span>
            </NavLink>
          ) : null}

          {auth.accessToken ? <MenuMobile /> : null}
        </div>

        <div className="flex justify-center grow lg:justify-self-center">
          {auth.accessToken ? (
            <NavLink to="/">
              <Logo />
            </NavLink>
          ) : (
            <Logo />
          )}
        </div>

        <div className="justify-self-end">
          {auth.accessToken && (
            <>
              <NavBar />
              <CartMobile />
            </>
          )}
        </div>
      </div>
      {/* BANNER sotto l'header, se c'è un messaggio attivo */}
      {banner && banner.is_active && location.pathname !== "/login" && (
        <div className="p-2 text-sm font-semibold text-center bg-yellow">
          {i18n.language === "it" ? banner.message_it : banner.message_en}
        </div>
      )}
    </>
  );
};

export default Header;
